export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.server) return; // Client-side auth only

  const { $authReady } = useNuxtApp();
  const { user } = useAuth();

  // Wait for Firebase Auth to initialize
  await $authReady;

  if (!user.value && to.path.startsWith("/admin")) {
    return navigateTo("/login");
  }
});
